import axios from "axios";
import Constant from "../Utils/Constant";
const AxiosInstance = axios.create({
  baseURL: Constant.BASE_URL,
});
AxiosInstance.interceptors.request.use(
  function (config) {
    const interpreter = JSON.parse(localStorage.getItem("Interpreto"));
    config.headers.token = interpreter?.auth_details?.token;
    config.headers.apikey = interpreter?.auth_details?.apikey;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

AxiosInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  // function (error) {
  //   if (error.response) {
  //     if (error.response.status === 401) {
  //       localStorage.removeItem("Interpreto");
  //       window.location.pathname = "/";
  //     } else {
  //       console.error("Response Error:", error.response);
  //     }
  //   } else if (error.request) {
  //     console.error("Request Error:", error.request);
  //   } else {
  //     console.error("Error:", error.message);
  //   }
  //   return Promise.reject(error);
  // }
);

export default AxiosInstance;
